import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import { Mutation } from 'react-apollo'
import { fetchDailyManagement } from '../../dailyManagement/dailyManagementQueries'
import css from './IncentivesPanel.css'
import { getStaffingPlan, increaseThumbsUpCard } from './incentivesPanelQueries'
import type { StaffingPlanVariables } from './types'
type Props = {
  label: string
  thumbsUpItemId: string
  variables: StaffingPlanVariables
  registerThumbUp: (...args: Array<any>) => any
  stationId: string
  date: string
}
type State = {
  loading: boolean
}

class AddThumbsUpButton extends React.Component<Props, State> {
  state = {
    loading: false,
  }
  handleClick = (onMutate: (...args: Array<any>) => any, thumbsUpItemId: string) => {
    const { registerThumbUp } = this.props
    registerThumbUp(onMutate, thumbsUpItemId)
  }

  render() {
    const { label, variables, thumbsUpItemId, date, stationId } = this.props
    return (
      <Mutation
        mutation={increaseThumbsUpCard}
        refetchQueries={() => [
          {
            query: getStaffingPlan,
            variables,
            skip: !variables || !variables.stationId || !variables.date,
          },
          {
            query: fetchDailyManagement,
            variables: {
              stationId,
              date: date,
              mode: 'Day',
              status: 'InProgress',
            },
          },
        ]}
      >
        {(onMutate, { loading }) => (
          <div className={css.incentiveItemContainer}>
            <Button
              className={css.addButton}
              variant='contained'
              color='primary'
              onClick={() => this.handleClick(onMutate, thumbsUpItemId)}
              disabled={loading}
            >
              {loading ? <CircularProgress /> : <span>{label}</span>}
            </Button>
          </div>
        )}
      </Mutation>
    )
  }
}

export default AddThumbsUpButton
